import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';
import { emitter } from 'shared/helpers/mitt';

// Store pending timeouts by conversation ID to cancel them when marking as unread
const pendingReadTimeouts = new Map();

export default {
  markMessagesRead: async ({ commit }, data) => {
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      emitter.emit('fetch_conversation_stats', data);
      
      // Cancel any existing timeout for this conversation
      if (pendingReadTimeouts.has(id)) {
        clearTimeout(pendingReadTimeouts.get(id));
      }
      
      // Set new timeout and store its ID
      const timeoutId = setTimeout(() => {
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        pendingReadTimeouts.delete(id);
      }, 4000);
      
      pendingReadTimeouts.set(id, timeoutId);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      // Cancel any pending "mark as read" timeout for this conversation
      // This prevents the race condition where marking unread gets overwritten
      if (pendingReadTimeouts.has(id)) {
        clearTimeout(pendingReadTimeouts.get(id));
        pendingReadTimeouts.delete(id);
      }
      
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      emitter.emit('fetch_conversation_stats', { id, unreadCount });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
